export const Icon = ({ Name }) => <Name size={20} />;
